import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLspOnboarding } from "./lspSlice";
import { fetchServices } from "../../../components/global-entities/globalEntitiesSlice";
import { fetchAllEntites } from "../../MyEntityDashboard/myEntityDashboardSlice";

const useLspPortfolio = () => {
  const dispatch = useDispatch();
  const refPanel = useRef(null);

  const {
    entityLists,
    selectedServices,
    accessList,
    accesspaginationFirst,
    accesspaginationRows,
    activeIndex,
    isDeleteAccesModal = false,
    deleteEntity,
    updateBtnAvailbel = false,
    accessmsg,
    removeMsg,
  } = useSelector((state) => state.lsponboarding);

  const { entityservices } = useSelector((state) => state.globalEntities);
  const { allentites } = useSelector((state) => state.myentitydashboard);
  const [updatEntity, setIsUpdatEntity] = useState([]);

  useEffect(() => {
    dispatch(fetchAllEntites());
    dispatch(fetchServices());
  }, [dispatch]);

  useEffect(() => {
    filterEntities(allentites);
  }, [allentites]);

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, accessList]);

  const handleEnableNext = () => {
    if (activeIndex === 3) {
      if (accessList && accessList.length > 0) {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };

  const updateMsgState = () => {
    dispatch(setLspOnboarding({ key: "accessmsg", value: "" }));
    dispatch(setLspOnboarding({ key: "removeMsg", value: "" }));
  };

  function getEntityNameById(id) {
    const entity = entityLists.find((e) => e.id === id);
    return entity ? entity.name : null;
  }

  function getServiceIdsForEntity(entityId) {
    const user = accessList.find((u) => u.entity.id === entityId);
    return user ? user.services.map((s) => s.id) : [];
  }
  const filteredEntityNames = () => {
    const entityNames = selectedServices
      .filter((selected) => {
        const entityId = selected.entity_id;
        const existingServices = getServiceIdsForEntity(entityId);
        const isNewEntity = existingServices.length === 0;
        const areServicesDifferent =
          !isNewEntity &&
          JSON.stringify(selected.services.sort()) !==
            JSON.stringify(existingServices.sort());

        return isNewEntity || areServicesDifferent;
      })
      .map((selected) => getEntityNameById(selected.entity_id))
      .filter(Boolean);

    let formattedNames;

    if (entityNames.length === 0) {
      formattedNames = "";
    } else if (entityNames.length === 1) {
      formattedNames = entityNames[0];
    } else if (entityNames.length === 2) {
      formattedNames = entityNames.join(" and ");
    } else {
      const lastEntityName = entityNames.pop();
      formattedNames = `${entityNames.join(", ")} and ${lastEntityName}`;
    }
    return formattedNames;
  };

  const filterEntities = (entities) => {
    const availableEntities = entities?.filter(
      (entity) => entity?.active_services?.length > 0,
    );
    dispatch(
      setLspOnboarding({ key: "entityLists", value: availableEntities }),
    );
  };

  const handleCloseMenu = () => refPanel?.current?.hide();
  const handleSetMenu = (event) => refPanel?.current?.toggle(event);

  const handleSelection = () => {
    handleCloseMenu();
    const customeraccessList = selectedServices.map((item) => {
      const entity = allentites.find((e) => e.id === item.entity_id);
      const serviceDetails = item.services.map((serviceId) =>
        entityservices.find((s) => s.id === serviceId),
      );
      return {
        entity: entity,
        services: serviceDetails,
      };
    });
    dispatch(setLspOnboarding({ key: "updateBtnAvailbel", value: false }));
    dispatch(
      setLspOnboarding({ key: "accessList", value: customeraccessList }),
    );
    dispatch(
      setLspOnboarding({
        key: "accessmsg",
        value: `${filteredEntityNames()} have been linked to the customer profile`,
      }),
    );
  };

  const searchEntity = (searchTerm) => {
    const filtered = allentites.filter((entity) =>
      entity.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    filterEntities(filtered);
  };

  const handlSelectedService = (event, entityId, serviceId) => {
    const existingEntity = selectedServices.find(
      (service) => service.entity_id === entityId,
    );
    if (existingEntity) {
      const updatedServices = event
        ? [...new Set([...existingEntity.services, serviceId])]
        : existingEntity.services.filter((id) => id !== serviceId);

      if (updatedServices.length === 0) {
        const ser = selectedServices.filter(
          (service) => service.entity_id !== entityId,
        );
        dispatch(setLspOnboarding({ key: "selectedServices", value: ser }));
      }
      const d = selectedServices.map((service) =>
        service.entity_id === entityId
          ? { ...service, services: updatedServices }
          : service,
      );
      dispatch(setLspOnboarding({ key: "selectedServices", value: d }));
    } else {
      const d = event
        ? [...selectedServices, { entity_id: entityId, services: [serviceId] }]
        : selectedServices;

      dispatch(setLspOnboarding({ key: "selectedServices", value: d }));
    }
  };

  const paginationOnchange = (e) => {
    dispatch(
      setLspOnboarding({ key: "accesspaginationFirst", value: e.first }),
    );
    dispatch(setLspOnboarding({ key: "accesspaginationRows", value: e.rows }));
  };

  const openDeleteModal = (data) => {
    dispatch(setLspOnboarding({ key: "isDeleteAccesModal", value: true }));
    dispatch(setLspOnboarding({ key: "deleteEntity", value: data }));
  };
  const closeDeleteModal = () => {
    dispatch(setLspOnboarding({ key: "isDeleteAccesModal", value: false }));
    dispatch(setLspOnboarding({ key: "deleteEntity", value: null }));
  };
  const deleteUserAccess = () => {
    const selected = [...selectedServices];
    const updatedAccess = selected.filter(
      (item) => item.entity_id !== deleteEntity.id,
    );

    const list = [...accessList];
    const updatedlist = list.filter(
      (item) => item.entity.id !== deleteEntity.id,
    );

    dispatch(
      setLspOnboarding({ key: "selectedServices", value: updatedAccess }),
    );
    dispatch(setLspOnboarding({ key: "accessList", value: updatedlist }));
    dispatch(
      setLspOnboarding({
        key: "removeMsg",
        value: `${deleteEntity?.name} was removed from customer portfolio`,
      }),
    );
    closeDeleteModal();
  };

  const hanleChangeUpdateAccess = (event, entityId, serviceId) => {
    handlSelectedService(event, entityId, serviceId);

    const exists = updatEntity.some(
      (item) => item.entityId === entityId && item.serviceId === serviceId,
    );

    if (!exists) {
      setIsUpdatEntity((prev) => [
        ...prev,
        {
          entityId: entityId,
          serviceId: serviceId,
          checked: event,
        },
      ]);
    } else {
      let updatedList = updatEntity.map((item) =>
        item.entityId === entityId && item.serviceId === serviceId
          ? { ...item, checked: event }
          : item,
      );
      setIsUpdatEntity(updatedList);
    }
  };
  const handleDiscardUpdate = () => {
    for (let x of updatEntity) {
      handlSelectedService(false, x.entityId, x.serviceId);
    }
    setIsUpdatEntity([]);
  };

  useEffect(() => {
    let flag = false;
    for (let updateItem of updatEntity) {
      const userEntity = accessList.find(
        (item) => item.entity.id === updateItem.entityId,
      );
      if (userEntity) {
        const serviceExists = userEntity.services.some(
          (service) => service.id === updateItem.serviceId,
        );
        if (
          (updateItem.checked && !serviceExists) ||
          (!updateItem.checked && serviceExists)
        ) {
          flag = true;
          break;
        }
      } else {
        flag = true;
        break;
      }
    }
    dispatch(setLspOnboarding({ key: "updateBtnAvailbel", value: flag }));
  }, [updatEntity]);

  const handleSaveUpdateAccess = () => {
    const customeraccessList = selectedServices.map((item) => {
      const entity = allentites.find((e) => e.id === item.entity_id);
      const serviceDetails = item.services.map((serviceId) =>
        entityservices.find((s) => s.id === serviceId),
      );
      return {
        entity: entity,
        services: serviceDetails,
      };
    });
    dispatch(setLspOnboarding({ key: "updateBtnAvailbel", value: false }));
    dispatch(
      setLspOnboarding({ key: "accessList", value: customeraccessList }),
    );
    dispatch(
      setLspOnboarding({
        key: "accessmsg",
        value: `The customer profile access has been successfully updated.`,
      }),
    );
  };
  return {
    entityservices,
    entityLists,
    refPanel,
    handleCloseMenu,
    handleSetMenu,
    handleSelection,
    selectedServices,
    searchEntity,
    handlSelectedService,
    accessList,
    paginationOnchange,
    accesspaginationFirst,
    accesspaginationRows,

    openDeleteModal,
    isDeleteAccesModal,
    closeDeleteModal,
    deleteEntity,
    deleteUserAccess,

    hanleChangeUpdateAccess,
    handleSaveUpdateAccess,
    updatEntity,
    handleDiscardUpdate,
    updateBtnAvailbel,

    accessmsg,
    removeMsg,
    updateMsgState,
  };
};

export default useLspPortfolio;
